// @ts-nocheck
import { takeLatest } from 'redux-saga/effects';
import {
	createFetchColumnsSaga,
	createFetchOrderDataSaga,
	createFetchAvailabilitySaga,
} from 'pages/orderShared/createOrderSagas';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import * as constants from './constants';

const handleFetchColumns = createFetchColumnsSaga({
	primaryGroupKey: 'kit',
	primaryKeywords: constants.COLUMN_KIT_KW,
	columnKeys: ['kit', 'store', 'warehouse', 'order'],
	logPrefix: '[OBS-Kit]',
	slice,
	constants,
});

const handleFetchOrderData = createFetchOrderDataSaga({
	selectRowKey: constants.SELECT_ROW_KEY,
	logPrefix: '[OBS-Kit]',
	slice,
	constants,
});

const handleFetchKitAvailability = createFetchAvailabilitySaga({
	idField: 'kitId',
	logPrefix: '[OBS-Kit]',
	slice,
});

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.fetchKitColumns, handleFetchColumns),
		yield takeLatest(sagaActions.fetchKitOrderData, handleFetchOrderData),
		yield takeLatest(sagaActions.fetchKitAvailability, handleFetchKitAvailability),
	];
}
